'use client'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Container,
  Typography,
  useMediaQuery,
} from '@mui/material'
import React, { SyntheticEvent, useState } from 'react'
import { faqs } from '../utility/constants/faq'
import { CaretDown } from '@/modules/shared/ui/localComponents/svg-icons'
import { theme } from '@/modules/shared/ui/kit/theme'

export default function Faq() {
  const [expanded, setExpanded] = useState<PanelId | false>('panel0')
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  type PanelId = string
  const handleChange =
    (panel: PanelId) => (_: SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false)
    }

  return (
    <Container maxWidth='lg'>
      <Box
        paddingY={isMobile ? 'var(--spacing__SCF_spacingS)' : '120px'}
        display={'flex'}
        flexDirection={'column'}
      >
        <Chip
          label='سوالات متداول'
          variant={'filled'}
          sx={{
            color: 'primaryBrandText',
            backgroundColor: 'primaryBrandBg4',
            fontSize: isMobile ? '12px' : '16px',
            fontWeight: '400',
            borderRadius: 'var(--cornerRadius__SCF_cornerRadiusCircular)',
            mb: 'var(--spacing__SCF_spacingS)',
            alignSelf: 'center',
          }}
        />
        <Typography
          fontSize={isMobile ? '20px' : '28px'}
          fontWeight={'700'}
          color='text1'
          mb={'45px'}
          textAlign={'center'}
        >
          سوالات متداول درباره جیحون
        </Typography>
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={'var(--spacing__SCF_spacingL)'}
          sx={{
            '& .MuiPaper-root.MuiAccordion-root': {
              borderRadius: 'var(--cornerRadius__SCF_cornerRadiusM)',
            },
            '& .MuiPaper-root.MuiAccordion-root:first-of-type': {
              borderRadius: 'var(--cornerRadius__SCF_cornerRadiusM)',
            },
            '& .MuiPaper-root.MuiAccordion-root:last-of-type': {
              borderRadius: 'var(--cornerRadius__SCF_cornerRadiusM)',
            },
          }}
        >
          {faqs.map((faq, index) => {
            return (
              <Accordion
                key={index}
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
                sx={{
                  border: '1px solid',
                  borderColor: 'stroke2',
                  borderRadius: 'var(--cornerRadius__SCF_cornerRadiusM)',
                  '&::before': {
                    display: 'none',
                  },
                  '&.Mui-expanded': {
                    margin: 0,
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<CaretDown />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                  sx={{
                    '& .MuiAccordionSummary-content': {
                      margin: '16px 0',
                    },
                    '& .MuiAccordionSummary-content.Mui-expanded': {
                      margin: '0 0',
                    },
                  }}
                >
                  <Typography
                    variant={isMobile ? 'BodyMedium' : 'BodyLargeMedium'}
                    color='text1'
                  >
                    {faq.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    variant={isMobile ? 'BodyMedium' : 'BodyLargeMedium'}
                    color='text2'
                  >
                    {faq.description}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            )
          })}
        </Box>
      </Box>
    </Container>
  )
}
